'use client'

import useSession from '@/app/(public)/auth/_components/hooks/use-session'
import { logger } from '@/lib/logger'
import { Session } from '@/types/core-types'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import UserDropdown from './user-dropdown'

type LoginLinkProps = {
  returnPath?: string
  session?: Session | null
}

export const LoginLink = (props: LoginLinkProps) => {
  const path = usePathname()
  const { session } = useSession()
  return (
    <ul className="flex list-none flex-col lg:ml-auto lg:flex-row">
      {session?.isAnonymous == false ? (
        <li className="flex items-center">
          <UserDropdown />
        </li>
      ) : (
        <li className="flex items-center">
          <Link
            className="hover:text-blueGray-500 text-blueGray-700 flex items-baseline px-3 py-4 text-xs font-bold uppercase lg:py-2"
            href={`/login?return=${path}`}
          >
            <i className="text-blueGray-500 fa-solid fa-lock mr-2 text-lg" /> Login
          </Link>
        </li>
      )}
    </ul>
  )
}

export default LoginLink
